import * as React from 'react';

import { Row, Column, ColumnSize } from './Grid';
import Panel from './Panel';

interface FormButtonsProps extends React.HTMLProps<HTMLDivElement> {
	// Me gustaría llamarlo size en lugar de width, pero no puedo porque ya existe en HTMLProps
	width: ColumnSize;
	offset?: ColumnSize;
}

export default class FormButtons extends React.Component<FormButtonsProps, { floating: boolean }> {

	private buttonProps: FormButtonsProps;

	constructor(props: FormButtonsProps) {
		super(props);

		this.buttonProps = props;

		this.state = { floating: false };
		this.handleScroll = this.handleScroll.bind(this);
	}

	private getWrapper(): HTMLElement {
		const wrapper = document.getElementById('wrapper');
		if (!wrapper)
			throw Error('Cannot find wrapper element on page required for sticky form buttons');
		return wrapper;
	}

	componentDidMount() {
		this.getWrapper().addEventListener('scroll', this.handleScroll, { passive: true });
		this.setState({ floating: this.shouldBeFloating() });
	}

	componentWillUnmount() {
		this.getWrapper().removeEventListener('scroll', this.handleScroll);
	}

	handleScroll() {
		this.setState({ floating: this.shouldBeFloating() });
	}

	private shouldBeFloating(): boolean {
		const wrapper = this.getWrapper();

		const totalHeight = wrapper.scrollHeight;
		const visibleHeight = wrapper.clientHeight;
		const topVisible = wrapper.scrollTop;

		// Si el contenido de la pantalla que tenemos arriba más el visible que estamos viendo 
		// es menor o igual a el total del alto de la pantalla -25px, el panel no debe ser flotante.
		return topVisible + visibleHeight <= totalHeight - 25;
	}

	render() {


		if (!this.state.floating) {
			const { width, offset } = { width: this.buttonProps.width, offset: this.buttonProps.offset, };
			const rest = this.props;

			return <Row className='m-t form-buttons' {...rest}>
				<Column width={width} offset={offset}>
					<Panel className={this.state.floating ? 'floating' : ''} bodyClassName='text-center'>
						{this.props.children}
					</Panel>
				</Column>
			</Row>;
		}

		return <Panel className={'form-buttons ' + (this.state.floating ? 'floating' : '')} bodyClassName='text-center'>
			{this.props.children}
		</Panel>;
	}
}
